import { Checkbox } from "@fluentui/react";
import React, { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { Column, TaxonomyFilter as TaxonomyFilterType } from "./types";
import { ColumnOptionsContext } from "./ColumnOptions";

type Props = {
  column: Column;
};

export const TaxonomyFilter = ({ column }: Props) => {
  const filter = column.filter as TaxonomyFilterType;
  const selectedValues = filter.value;

  const renderLabel = filter.renderLabel;
  const { taxonomy, setFilter, t } = useContext(ColumnOptionsContext);
  const [maxSelectionReached, setMaxSelectionReached] = useState(false);

  const taxonomyList = taxonomy[filter.taxonomyKey] || [];
  const options = taxonomyList
    .filter((tax) => {
      if (filter.exclude) {
        return !filter.exclude.includes(tax.code);
      }
      return true;
    })
    .sort((a, b) => {
      const labelA = (filter.customOptionLabel ? filter.customOptionLabel(a) : t(a.code)).toLowerCase();
      const labelB = (filter.customOptionLabel ? filter.customOptionLabel(b) : t(b.code)).toLowerCase();
      return labelA.localeCompare(labelB);
    });

  useEffect(() => {
    if (
      filter?.maxOptionsSelect &&
      selectedValues.length >= filter.maxOptionsSelect
    ) {
      setMaxSelectionReached(true);
    } else {
      maxSelectionReached && setMaxSelectionReached(false);
    }
  }, [selectedValues, filter?.maxOptionsSelect, maxSelectionReached]);

  return (
    <div>
      {options.map((tax) => {
        const isChecked = selectedValues.includes(tax.id);
        return (
          <CheckboxWrapper key={tax.id}>
            <Checkbox
              checked={isChecked}
              disabled={maxSelectionReached && !isChecked}
              onChange={(_, checked) => {
                let value;
                if (checked) {
                  if (maxSelectionReached && !isChecked) return;
                  value = selectedValues.concat([tax.id]);
                } else {
                  value = selectedValues.filter((id) => id !== tax.id);
                }
                setFilter(column.key, {
                  ...filter,
                  value,
                });
              }}
              styles={{ root: { marginRight: 2 } }}
            />
            {renderLabel ? (
              renderLabel({ taxonomy: tax, t })
            ) : (
              <TruncatedText>{t(tax.code)}</TruncatedText>
            )}
          </CheckboxWrapper>
        );
      })}
    </div>
  );
};

const CheckboxWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 5px 0;
  &:first-child {
    padding-top: 0;
  }
  &:last-child {
    padding-bottom: 0;
  }
`;

const TruncatedText = styled.span`
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
